import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Nav = () => {
  const location = useLocation();

  const isActive = (href) => {
    if (href.startsWith('/#')) {
      return location.pathname === '/' && location.hash === href.replace('/', '');
    }
    return location.pathname === href;
  };

  const handleNavToggle = () => {
    const header = document.querySelector('.site-header');
    const btn = document.querySelector('.nav-toggle');
    const isOpen = header.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen);
  };

  const closeNav = () => {
    const header = document.querySelector('.site-header');
    const btn = document.querySelector('.nav-toggle');
    if (header && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  };

  React.useEffect(() => {
    // Auto-close menu on route change (useful for mobile)
    closeNav();
  }, [location.pathname, location.hash]);

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="brand">
          <img src="/images/timeline_express_logo.webp" alt="Timeline Express" />
        </Link>
        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded="false"
          onClick={handleNavToggle}
        >
          <span className="nav-toggle-bar"></span>
          <span className="nav-toggle-bar"></span>
          <span className="nav-toggle-bar"></span>
        </button>
        <div className='header-right'>
          <nav className="main-nav">
            <Link to="/" className={isActive('/') ? 'is-active' : ''} onClick={closeNav}>Home</Link>
            <Link to="/services" className={isActive('/services') ? 'is-active' : ''} onClick={closeNav}>Services</Link>
            <Link to="/about" className={isActive('/about') ? 'is-active' : ''} onClick={closeNav}>About Us</Link>
            <Link to="/contact" className={isActive('/contact') ? 'is-active' : ''} onClick={closeNav}>Contact Us</Link>
          </nav>
          {/* commented out the search field */}
          {/* <form className="search" role="search" onSubmit={(e) => e.preventDefault()}>
            <input type="search" placeholder="Search" aria-label="Search" />
            <button className="search-btn" aria-label="Submit search" type="submit">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M11 19a8 8 0 1 1 5.292-14.03A8 8 0 0 1 11 19Zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" fill="currentColor" />
                <path d="M20.707 19.293l-3.387-3.387a1 1 0 1 0-1.414 1.414l3.387 3.387a1 1 0 0 0 1.414-1.414Z" fill="currentColor" />
              </svg>
            </button>
          </form> */}
        </div>
      </div>
    </header>
  );
};

export default Nav;
